import countries from "i18n-iso-countries";
// import { countriesAndCurrencies } from "@/utils/Json";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export const getCountryCodeByName = (countryName: string) => {
  return countries.getAlpha2Code(countryName, "en") || "";
};

export const formatDate = (dateString: string) => {
  if (!dateString) {
    return "-"; // Return null for null or empty date string
  }
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long", // This will give you the full month name
    day: "numeric",
  };

  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", options); // 'en-US' for English locale
};
export const getFromLocalStorage = (key: any) => {
  if (typeof window !== "undefined") {
    let value = localStorage.getItem(key);
    return value;
  }
};

export const calculateTotalPages = (
  totalRows: number,
  rowsPerPage: number
): number => {
  if (rowsPerPage) {
    return Math.ceil(totalRows / rowsPerPage);
  } else {
    return 0;
  }
};

export const formatDuration = (duration: any) => {
  const parts = duration.split(":");
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);

  let result = [];

  if (hours > 0) {
    result.push(`${hours} hr${hours > 1 ? "s" : ""}`);
  }
  if (minutes > 0) {
    result.push(`${minutes} min${minutes > 1 ? "s" : ""}`);
  }
  if (seconds > 0) {
    result.push(`${seconds} sec${seconds > 1 ? "s" : ""}`);
  }

  return result.join(" ") || "0 secs";
};
export const toCamelCase = (str: string) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
};

export const calculateDate = (filterType: any) => {
  const currentDate = new Date();
  let calculatedDate;

  switch (filterType) {
    case "lastWeek":
      calculatedDate = new Date(currentDate.setDate(currentDate.getDate() - 7));
      break;
    case "lastMonth":
      calculatedDate = new Date(
        currentDate.setMonth(currentDate.getMonth() - 1)
      );
      break;
    case "lastThreeMonths":
      calculatedDate = new Date(
        currentDate.setMonth(currentDate.getMonth() - 3)
      );
      break;
    case "lastSixMonths":
      calculatedDate = new Date(
        currentDate.setMonth(currentDate.getMonth() - 6)
      );
      break;
    default:
      calculatedDate = null;
  }
  return calculatedDate ? calculatedDate.toISOString().split("T")[0] : null;
};

export const handlelayout = () => {
  const mainWrapper = document.getElementById("main-wrapper");
  const pagewrapper = document.getElementsByClassName("page-wrapper");
  if (mainWrapper) {
    mainWrapper.setAttribute("data-sidebartype", "mini-sidebar");
    Array.from(pagewrapper).forEach((pageWrapper) => {
      pageWrapper.classList.add("toggle-size");
    });
  }
};
export const handleMouseLeave = (
  event: React.MouseEvent,
  customizerRef: any
) => {
  // Check if relatedTarget is null or if it's not contained in the customizer
  if (
    customizerRef.current &&
    event.relatedTarget instanceof Node &&
    !customizerRef.current.contains(event?.relatedTarget as Node)
  ) {
    const mainWrapper = document.getElementById("main-wrapper");
    const pagewrapper = document.getElementsByClassName("page-wrapper");
    const customizers = document.getElementsByClassName("customizer");

    if (mainWrapper) {
      mainWrapper.setAttribute("data-sidebartype", "full");
      Array.from(pagewrapper).forEach((pageWrapper) => {
        pageWrapper.classList.remove("toggle-size");
      });
      Array.from(customizers).forEach((customizers) => {
        customizers.classList.remove("show-service-panel");
      });
    }
  }
};

export const capitalizeFirstLetter = (string: string) => {
  if (string) {
    return (
      string?.charAt(0).toUpperCase() +
      string?.slice(1, string.length).toLowerCase()
    );
  }
};

export const getCookie = (name: any) => {
  function escape(s: any) {
    return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, "\\$1");
  }
  let match = document.cookie.match(
    RegExp("(?:^|;\\s*)" + escape(name) + "=([^;]*)")
  );
  return match ? match[1] : null;
};

export const deleteCookie = (
  name: string,
  path: string = "/",
  domain: string = ""
) => {
  const expires = `expires=${new Date(0).toUTCString()}`;
  const cookie = `${name}=; path=${path}; ${expires};`;
  const domainCookie = domain ? `${cookie} domain=.${domain};` : cookie;
  document.cookie = domainCookie;
  document.cookie = cookie;
};

export const setCookie = (
  name: string,
  value: string,
  path: string = "/",
  days: number = 365
) => {
  let expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; Path=${path}; SameSite="Lax"; Secure:"True";`;
};

export function convertUTCToLocal(utcString: string) {
  const date = new Date(utcString); // JS auto converts UTC → local time

  const localDate = date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });

  const localTime = date.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return `${localDate} ${localTime}`;
}

export function toSentenceCase(str: string = "") {
  if (!str) return "";
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export const getFileExtension = (url: string): string => {
  try {
    const cleanUrl = url.split("?")[0]; // remove query params
    return cleanUrl.substring(cleanUrl.lastIndexOf(".") + 1).toLowerCase();
  } catch {
    return "";
  }
};
